module.exports = __webpack_public_path__ + "static/media/1B53BD43-843D-41CF-8784-0A37AEE4F885.f4c6b954.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/make_over/1B53BD43-843D-41CF-8784-0A37AEE4F885.jpg
// module id = 284
// module chunks = 0